import React = require("react");
import * as toolbarItemStyle from "../../css/components/toolbar/ToolbarItem.css";
import SimpleToolbarItem from "webc-reactcore/src/js/components/toolbar/SimpleToolbarItem";

export function ModifiedSimpleToolbarItem(props) {
    return <SimpleToolbarItem css={{compose: toolbarItemStyle}} {...props} />
}